module.exports = "/_next/static/images/a4f78008503757f28038038533fa6315-perks-md-2x.jpg";